/**
 * @generated SignedSource<<92147b16395451d8bfecdd9df74b8c13>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type url_issueFieldUrlReadviewFull_UrlReadView$data = {
  readonly id: string;
  readonly uri: string | null | undefined;
  readonly " $fragmentType": "url_issueFieldUrlReadviewFull_UrlReadView";
};
export type url_issueFieldUrlReadviewFull_UrlReadView$key = {
  readonly " $data"?: url_issueFieldUrlReadviewFull_UrlReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlReadviewFull_UrlReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "url_issueFieldUrlReadviewFull_UrlReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "uri"
    }
  ],
  "type": "JiraUrlField"
};

(node as any).hash = "6f1b369836bf61ff873cf37f18025e6a";

export default node;
